import styled from '@emotion/styled'

export const Card = styled.div`
  background-color: #fff;
  width: 100%;
  border-radius: var(--Radius-300);
  overflow: hidden;
`
